import { memo } from "react";
import type { Status as TransactionStatus } from "types";
import { Status } from "consts/transactions";
import withChipStatus from "./withChipStatus";
import type { ChipStatusProps } from "./types";

export default memo(withChipStatus<TransactionStatus>(
    new Map<TransactionStatus, ChipStatusProps<TransactionStatus>>()
        .set(Status.Pending, {
            icon: 'HourglassEmpty',
            color: 'warning'
        })
        .set(Status.Failed, {
            icon: 'SmsFailed',
            color: 'error'
        })
        .set(Status.Refunded, {
            icon: 'ThumbDownOffAlt',
            color: 'secondary'
        })
        .set(Status.Succeeded, {
            icon: 'CheckCircleOutline',
            color: 'success'
        })
        .set(Status.Refunded, {
            icon: 'LocalAtm',
            color: 'primary'
        })
        .set(Status.ChargeBack, {
            icon: 'CurrencyExchange',
            color: 'info'
        })
));
